import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/app/store/authStore';
import { paths } from '@/app/routes/routePaths';

export function DeveloperGuard() {
  const isDeveloper = useAuthStore((s) => s.user?.roles.some(r => r.name === 'developer'));

  if (!isDeveloper) {
    return <Navigate to={paths.forbidden} replace />;
  }

  return <Outlet />;
}
